import React from 'react';

export default function ScheduleActivity() {
	return <div> Activity</div>;
}
